const checkoutPageEN = {
    activateTitle: "Activate Your Shop",
    activateSubtitle: "Complete your subscription to start accepting bookings.",
    totalSeats: "Total Seats",
    staffSeats: "Staff Seats",
    poweredBy: "Secure payments powered by Paddle",
    stillThere: "Are you still there?",
    continue: "Continue",
};
export default checkoutPageEN